var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_c('i',{staticClass:"icon cl-accent"},[_vm._v("info")]),_vm._v(" "),_c('div',{staticClass:"text absolute p5 h5 bg-cl-th-accent cl-white"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }